import { useEffect, useState } from "react";
import { Tooltip } from "antd";
import {
  RefreshCw,
  Trash2,
  ChevronDown,
  ChevronUp,
  Grip,
  Loader2,
} from "lucide-react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { REQUIRED_TYPES, SECTION_META } from "./config.js";
// import { regenerateSection } from "../ai/aiStubs.js";

export default function SectionCardShell({
  id,
  type,
  data,
  onChange,
  onDelete,
  allCollapsed,
  extraActions,
  children,
}) {
  const meta = SECTION_META[type] ?? { title: type, subtitle: "" };
  const isRequired = REQUIRED_TYPES.includes(type);

  const [collapsed, setCollapsed] = useState(false);
  const [instruction, setInstruction] = useState("");
  const [regenerating, setRegenerating] = useState(false);

  const { attributes, listeners, setNodeRef, transform, transition, isDragging } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : 1,
  };

  useEffect(() => {
    setCollapsed(allCollapsed);
  }, [allCollapsed]);

  const handleRegenerate = async () => {
    setRegenerating(true);
    try {
      // const res = await regenerateSection({
      //   sectionType: type,
      //   currentData: data,
      //   instruction,
      //   targetJobTitle: "",
      // });
      // if (res?.data) onChange(res.data);
    } finally {
      setRegenerating(false);
      setInstruction("");
    }
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="border rounded-xl px-5 py-4 bg-white shadow-basic mb-3"
    >
      <div className="flex justify-between items-start">
        <div className="flex items-center gap-3">
          <span
            {...attributes}
            {...listeners}
            className="cursor-grab text-gray-400 hover:text-gray-600 touch-none"
            aria-label="Drag handle"
          >
            <Grip size={17} />
          </span>
          <div>
            <p className="font-semibold text-[#344054] text-[.92rem]">{meta.title}</p>
            {meta.subtitle && (
              <p className="text-[.85rem] text-[#667085]">{meta.subtitle}</p>
            )}
          </div>
        </div>

        <div className="flex gap-3 text-gray-500 items-center">
          {extraActions}

          {/* <Tooltip
            trigger={["click"]}
            overlayInnerStyle={{
              borderRadius: "6px",
              padding: "9px 15px",
              backgroundColor: "#0C111D",
              color: "#fff",
              width: "280px",
            }}
            title={
              <div>
                <p className="mb-2">Regenerate this section using AI</p>
                <textarea
                  placeholder="Optional instructions (e.g. make it more quantitative)"
                  className="w-full bg-[#0C111D] border border-white/40 rounded-md resize-none p-2 text-sm text-white placeholder-white/60"
                  rows={3}
                  value={instruction}
                  onChange={(e) => setInstruction(e.target.value)}
                />
                <button
                  onClick={handleRegenerate}
                  disabled={regenerating}
                  className="mt-2 mb-1 w-full btn-blue py-1 px-3 rounded-md flex items-center justify-center gap-2 disabled:opacity-60"
                >
                  {regenerating ? (
                    <Loader2 size={16} className="animate-spin" />
                  ) : (
                    <RefreshCw size={16} />
                  )}
                  {regenerating ? "Regenerating…" : "Regenerate using AI"}
                </button>
              </div>
            }
          >
            <RefreshCw
              size={18}
              className={`cursor-pointer hover:text-blue-600 ${regenerating ? "animate-spin text-blue-600" : ""}`}
            />
          </Tooltip> */}

          {isRequired ? (
            <Tooltip
              overlayInnerStyle={{
                borderRadius: "6px",
                padding: "9px 15px",
                backgroundColor: "#0C111D",
                color: "#fff",
                textAlign: "center",
              }}
              title="This section cannot be deleted"
            >
              <Trash2
                size={18}
                color="gray"
                className="opacity-60 cursor-not-allowed"
              />
            </Tooltip>
          ) : (
            <Trash2
              size={18}
              className="cursor-pointer hover:text-red-600"
              onClick={() => onDelete(id)}
            />
          )}

          <button
            onClick={() => setCollapsed((c) => !c)}
            className="text-gray-400 hover:text-gray-600"
            aria-label={collapsed ? "Expand section" : "Collapse section"}
          >
            {collapsed ? <ChevronDown size={18} /> : <ChevronUp size={18} />}
          </button>
        </div>
      </div>

      {!collapsed && (
        <div className="mt-3 pt-3 border-t">{children}</div>
      )}
    </div>
  );
}
